import moment from "moment";
import { Promise } from "core-js";
import { route, get, post } from "@utils/network";

export default {
    state: {
        user: null,
        token: null,
    },
    
    mutations: {
        SET_USER(state, user) {
            state.user = user ? { ...user } : null;
        },
        SET_TOKEN(state, token) {
            state.token = { ...token };
            localStorage.setItem("auth_token", JSON.stringify(token));
        },
        CLEAR_TOKEN(state) {
            state.token = null;
            localStorage.removeItem("auth_token");
        }

    },
    actions: {
        initializeAuthData(context, { user, token }) {
            context.commit("SET_USER", user);
            context.commit("SET_TOKEN", token);
        },

        setAuthUser(context, { user }) {
            context.commit("SET_USER", user);
        },

        setAuthToken(context, {  token }) {
            context.commit("SET_TOKEN", token);
        },

        login(context, { email, password, provider, provider_id }) {
            const data = {
                email: email || null,
                password: password || null,
                provider: provider || "email",
                provider_id: provider_id || null,
            };

            return new Promise((resolve, reject) => {
                post(route("login"), { data })
                .then(response => {
                    const { user, token } = response.data.result;
                    context.dispatch("initializeAuthData", { user, token });
                    resolve(response);
                })
                .catch(error => reject(error));
            });
        },

        logout(context) {
            context.commit("SET_USER", null);
            context.commit("CLEAR_TOKEN");
        },

        initializeToken(context) {
            let token = localStorage.getItem("auth_token");
            if (!token) {
                return;
            }
            token = JSON.parse(token);
            context.commit("SET_TOKEN", token);
            
            return new Promise((resolve, reject) => {
                const action = moment(token.expires_in).isAfter()
                    ? context.dispatch("initializeUser")
                    : context.dispatch("refreshToken");

                action.then(response => resolve(response))
                    .catch(error => reject(error));
            });
                
        },

        refreshToken(context) {
            return new Promise((resolve, reject) => {
                post(route("refresh-token"))
                    .then(response => {
                        const { user, token } = response.data.result;
                        context.dispatch("initializeAuthData", { user, token });
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },

        initializeUser(context) {
            return new Promise((resolve, reject) => {
                context.dispatch("fetchProfile")
                    .then(response => {
                        const { user } = response.data.result;
                        context.dispatch("setAuthUser", { user });
                        resolve(response)
                    })
                    .catch(error => {
                        console.error("Failed to initialize user data")
                        console.error(error);
                        reject(error)
                    })
            });
        },

        fetchProfile(context) {
            return get(route("users/profile"));
        },

    },
    getters: {
        tokenKey(context) {
            return context.token ? context.token.access_token : null;
        },
        
        tokenType(context) {
            return context.token ? context.token.token_type : null;
        },
        
        tokenExpiration(context) {
            return context.token ? moment(context.token.expires_in) : null;
        },
        authenticatedUser(context) {
            return {...context.user};
        },
        isAuthenticated(context) {
            return context.user && context.user.id;
        },
    }
};
